import { render, staticRenderFns } from "./purchase-list.vue?vue&type=template&id=6cb9b921&scoped=true&"
import script from "./purchase-list.vue?vue&type=script&lang=ts&"
export * from "./purchase-list.vue?vue&type=script&lang=ts&"
import style0 from "./purchase-list.vue?vue&type=style&index=0&id=6cb9b921&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb9b921",
  null
  
)

export default component.exports